import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { RouterModule } from '@angular/router';
import { CustomMaterialModule } from '@app/core/material.module';
import { DynamicFieldsModule } from '@app/modules/dynamic-fields/dynamic-fields.module';
import { ButtonModule } from '@components/button/modules/button.module';
import { ShowTooltipModule } from '@directives/show-tooltip/show-tooltip.module';
import { HeaderComponent } from './header.component';

@NgModule({
    declarations: [HeaderComponent],
    imports: [
        MatBadgeModule,
        CommonModule,
        CustomMaterialModule,
        RouterModule,
        FormsModule,
        FlexLayoutModule,
        DynamicFieldsModule,
        ButtonModule,
        ShowTooltipModule,
    ],
    exports: [HeaderComponent],
})
export class HeaderModule {}
